import IconImage from "../../../Common/Icons/IconImage";
import IconTick from "../../../Common/Icons/IconTick";
import { EngagementPanelResultString } from "../../../Common/Utility/helpers";
import { useObjectUrl } from "../../../Common/Utility/useObjectUrl";

interface MCQPictureInterface {
  answeringMode?: boolean;
  optionName: string;
  correct: boolean;
  file?: File;
  url?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
}

export default function MCQPicture(props: MCQPictureInterface) {
  const objectUrl = useObjectUrl(props.file);
  const imgSrc = objectUrl || props.url;

  return (
    <div
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onMouseUp={props.onMouseUp}
      onMouseDown={props.onMouseDown}
      className={`rounded-xl relative overflow-clip p-2.5 border-solid border-[3px] flex flex-col h-full w-full items-center justify-center ${
        props.correct ? " border-brij-Blue" : " border-brij-LightGrey"
      } ${props.onClick ? "cursor-pointer" : ""}`}
    >
      <span className="text-red-400 absolute left-1 top-1 text-md">
        {props.optionName}
      </span>
      {props.correct && !props.answeringMode && (
        <div className="w-6 stroke-[2.5px] stroke-brij-Blue inline-flex justify-center items-center">
          <IconTick />
        </div>
      )}
      <div
        className={`w-full h-full ${
          props.correct && !props.answeringMode ? "pb-1.5" : ""
        }`}
      >
        {imgSrc ? (
          <img
            src={imgSrc}
            alt="option"
            className="object-contain w-full h-full"
            decoding="async"
          />
        ) : (
          <div className="flex flex-col w-full h-full justify-center items-center gap-2 fill-brij-Grey p-2">
            <IconImage />
            <p className="text-small font-medium text-center leading-snug text-brij-Grey">
              No Image
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
